import styled from '@emotion/styled/macro';
import { Variables } from '../../base';

export const DetailPanel = styled.section`
    flex: 1;
    min-width: 0;
    min-height: 0;
    border-radius: 12px;
    box-shadow: ${Variables.Shadows.small}, ${Variables.Shadows.border};
    background-color: ${Variables.Colors.white};
    padding: 24px;
    overflow-y: auto;
`;

export const DetailHeader = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    color: ${Variables.Colors.p500};
    line-height: 1.3;
`;

export const DetailHeaderRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`;

export const WorkerKeyChip = styled.span`
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 12px;
    color: ${Variables.Colors.n70};
    background: ${Variables.Colors.n15_24};
    padding: 2px 7px;
    border-radius: 4px;
`;

export const DetailDescription = styled.p`
    margin: 8px 0 0;
    max-width: 680px;
    font-size: 14px;
    line-height: 1.5;
    color: ${Variables.Colors.n70};
`;

export const Divider = styled.hr`
    margin: 16px 0 24px;
    border: 0;
    border-top: 1px solid ${Variables.Colors.n15_48};
`;

export const EmptyState = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${Variables.Colors.n70};
`;

export const OptionList = styled.div`
    display: flex;
    flex-direction: column;

    &[data-readonly='true'] {
        pointer-events: none;
        opacity: 0.96;
    }
`;

/** Keeps API-driven worker options from crowding the rules list below. */
export const AutomationOptionsBlock = styled.div`
    flex: none;
    max-height: 240px;
    overflow-x: hidden;
    overflow-y: auto;
    margin-bottom: 8px;
    padding-right: 4px;
`;

export const DetailToolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 14px;
    flex: none;
`;

export const DetailHint = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: ${Variables.Colors.n70};
`;

export const ConfiguredCount = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
    white-space: nowrap;
`;

export const ComingSoonPanel = styled.div`
    padding: 20px;
    border: 1px dashed ${Variables.Colors.n15_48};
    border-radius: 10px;
    background: ${Variables.Colors.n15_24};
`;

export const ComingSoonTitle = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: ${Variables.Colors.p500};
    margin-bottom: 8px;
`;

export const ComingSoonText = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: ${Variables.Colors.n70};
`;
